import { api } from "./axios";
import type { User } from "../types";

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  must_change_password: boolean;
}

// Timeout corto para login: si el backend no responde, el usuario debe verlo
// rapido en lugar de quedarse esperando 30s con un spinner sin feedback.
const LOGIN_TIMEOUT_MS = 10_000;

export async function login(username: string, password: string): Promise<LoginResponse> {
  const params = new URLSearchParams();
  params.append("username", username);
  params.append("password", password);
  const r = await api.post("/auth/login", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    timeout: LOGIN_TIMEOUT_MS,
  });
  return r.data;
}

export async function me(): Promise<User> {
  const r = await api.get("/auth/me");
  return r.data;
}

export async function changePassword(old_password: string, new_password: string): Promise<void> {
  await api.post("/auth/change-password", { old_password, new_password });
}
